import { flattenDeep } from 'lodash-es';

export const HOURS = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
  '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];

export const MINUTES = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15',
  '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33',
  '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51',
  '52', '53', '54', '55', '56', '57', '58', '59'];

export const TIMES15 = flattenDeep(Array.from({ length: 24 }, (_, index) => {
  const hour = index.toString().padStart(2, '0');
  return ['00', '15', '30', '45'].map(minute => (`${hour}:${minute}`));
}));

export const TIMES30 = [
  { value: '00:00', text: '12:00am' },
  { value: '00:30', text: '12:30am' },
  { value: '01:00', text: '1:00am' },
  { value: '01:30', text: '1:30am' },
  { value: '02:00', text: '2:00am' },
  { value: '02:30', text: '2:30am' },
  { value: '03:00', text: '3:00am' },
  { value: '03:30', text: '3:30am' },
  { value: '04:00', text: '4:00am' },
  { value: '04:30', text: '4:30am' },
  { value: '05:00', text: '5:00am' },
  { value: '05:30', text: '5:30am' },
  { value: '06:00', text: '6:00am' },
  { value: '06:30', text: '6:30am' },
  { value: '07:00', text: '7:00am' },
  { value: '07:30', text: '7:30am' },
  { value: '08:00', text: '8:00am' },
  { value: '08:30', text: '8:30am' },
  { value: '09:00', text: '9:00am' },
  { value: '09:30', text: '9:30am' },
  { value: '10:00', text: '10:00am' },
  { value: '10:30', text: '10:30am' },
  { value: '11:00', text: '11:00am' },
  { value: '11:30', text: '11:30am' },
  { value: '12:00', text: '12:00pm' },
  { value: '12:30', text: '12:30pm' },
  { value: '13:00', text: '1:00pm' },
  { value: '13:30', text: '1:30pm' },
  { value: '14:00', text: '2:00pm' },
  { value: '14:30', text: '2:30pm' },
  { value: '15:00', text: '3:00pm' },
  { value: '15:30', text: '3:30pm' },
  { value: '16:00', text: '4:00pm' },
  { value: '16:30', text: '4:30pm' },
  { value: '17:00', text: '5:00pm' },
  { value: '17:30', text: '5:30pm' },
  { value: '18:00', text: '6:00pm' },
  { value: '18:30', text: '6:30pm' },
  { value: '19:00', text: '7:00pm' },
  { value: '19:30', text: '7:30pm' },
  { value: '20:00', text: '8:00pm' },
  { value: '20:30', text: '8:30pm' },
  { value: '21:00', text: '9:00pm' },
  { value: '21:30', text: '9:30pm' },
  { value: '22:00', text: '10:00pm' },
  { value: '22:30', text: '10:30pm' },
  { value: '23:00', text: '11:00pm' },
  { value: '23:30', text: '11:30pm' },
  { value: '23:59', text: '11:59pm' }
];

/**
 * Returns array of hours and minute strings
 * [00:00,...,23:59]
 */
export function getHoursMinutes() {
  return HOURS.map(hr => MINUTES.map(mn => `${hr}:${mn}`))
    .reduce((a, b) => a.concat(b), []);
}
